module.exports = __webpack_public_path__ + "img/logo-azul.ca41bf6e.png";